// import React, { useState } from "react";
// import "./formInput.css";

// function FormInputs(props) {
//   const [focused, setFocused] = useState(false);
//   const {
//     width,
//     padding,
//     height,
//     label,
//     errorMessage,
//     required,
//     onChange, 
//     icon,
//     bg,
//     ...inputProps
//   } = props;

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   return (
//     <div className="formInput">
//       <label>
//         {label}
//         {required && <span>*</span>}
//       </label>
//       <input
//         {...inputProps}
//         onChange={onChange}
//         onBlur={handleFocus}
//         onFocus={handleFocus}
//         focused={focused.toString()}
//         style={{ height, padding, width, backgroundColor: bg}}
//       />
//     </div>
//   );
// }

// export default FormInputs;







import React, { useState } from "react";
import "./formInput.css";

function FormInputs(props) {
  const [focused, setFocused] = useState(false);
  const {
    width,
    padding,
    height,
    label,
    errorMessage,
    required,
    onChange,
    icon,
    bg,
    ...inputProps
  } = props;

  const handleFocus = () => {
    setFocused(true);
  };

  // const handleChange = (event) => {
  //   const { value } = event.target;

  //   // Validate the datetime-local input to ensure year is exactly 4 digits
  //   if (inputProps.type === "datetime-local") {
  //     const dateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
  //     const yearPattern = /^\d{4}$/;
  //     const dateTimeParts = value.split("T");
  //     const dateParts = dateTimeParts[0]?.split("-");

  //     // Ensure year part has exactly 4 digits and date-time pattern is valid
  //     if (dateParts.length === 3 && dateParts[0].length > 4) {
  //       dateParts[0] = dateParts[0].slice(0, 4); // Limit the year part to 4 digits
  //       const correctedValue = `${dateParts.join("-")}T${dateTimeParts[1] || ""}`;
  //       event.target.value = correctedValue;
  //       onChange(event);
  //     } else {
  //       onChange(event);
  //     }
  //   } else {
  //     onChange(event);
  //   }
  // };
  const handleChange = (event) => {
    const { value } = event.target;
  
    // Validate the datetime-local input to ensure year is exactly 4 digits
    if (inputProps.type === "datetime-local") {
      const dateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
      const yearPattern = /^\d{4}$/;
      const dateTimeParts = value.split("T");
      const dateParts = dateTimeParts[0]?.split("-");
  
      // Ensure year part has exactly 4 digits and date-time pattern is valid
      if (dateParts.length === 3 && dateParts[0].length > 4) {
        const correctedYear = dateParts[0][0] + dateParts[0].slice(-3); // Pick the first digit and last 3 digits of the year part
        const correctedValue = `${correctedYear}-${dateParts[1]}-${dateParts[2]}T${dateTimeParts[1] || ""}`;
        event.target.value = correctedValue;
        onChange(event);
      } else {
        onChange(event);
      }
    } else {
      onChange(event);
    }
  };

  return (
    <div className="formInput">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        {...inputProps}
        onChange={handleChange}
        onBlur={handleFocus}
        onFocus={handleFocus}
        focused={focused.toString()}
        style={{ height, padding, width, backgroundColor: bg }}
      />
    </div>
  );
}

export default FormInputs;






